import React, { useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';
import PublicNavbar from 'components/PDFSignature/PublicNavbar';
import { useLocation, useParams } from 'react-router-dom';

import PublicPDFSignatureViewer from '../../components/PDFSignature/PublicPDFSignatureViewer';
import {
  cleanPathUrl,
  downloadPdfBlob,
  extractPathUrlFromWindow,
  ParsedUrl,
  parseS3Url,
} from './signContract.utils';

const SignContract: React.FC = () => {
  const { signerId } = useParams<{ signerId: string }>();
  const location = useLocation();
  const [pdfUrl, setPdfUrl] = useState<string>('');
  const [parsedUrl, setParsedUrl] = useState<ParsedUrl | null>(null);

  useEffect(() => {
    // Extract PDF URL from pathUrl parameter using utility
    const pathUrlParam = extractPathUrlFromWindow();
    if (pathUrlParam) {
      // Clean the URL by removing everything from contractId onwards
      const cleanedPDFPathUrl = cleanPathUrl(pathUrlParam);

      // Parse the URL to extract components using utility
      const URLObject = parseS3Url(pathUrlParam);
      setParsedUrl(URLObject);
      setPdfUrl(cleanedPDFPathUrl);
    }
  }, []);

  const handlePdfSave = (pdfBytes: Uint8Array) => {
    downloadPdfBlob(pdfBytes);
  };

  const handleSignClick = () => {
    // Sign click handler
  };

  return (
    <>
      <PublicNavbar />
      <Box
        sx={{
          display: 'flex',
          height: '100vh',
          width: '100%',
          overflow: 'hidden',
        }}
      >
        {/* Left - PDF Viewer */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            padding: 2,
            mt: 12,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2 }}>
            Sign Contract
          </Typography>

          {pdfUrl ? (
            <>
              <PublicPDFSignatureViewer
                pdfUrl={pdfUrl}
                signerId={parsedUrl?.uuid}
                fileLocation={parsedUrl?.bucketId + '/' + parsedUrl?.filePath}
                contractId={parsedUrl?.contractId}
                emailId={parsedUrl?.email}
                fullFilePath={
                  parsedUrl?.fullFilePath + '/' + parsedUrl?.filename
                }
              />
            </>
          ) : (
            <Typography>Loading contract document...</Typography>
          )}
        </Box>

        {/* Right - Sidebar */}
        {/* <PublicSignSidebar
        onSignClick={handleSignClick}
        onDownload={() => handlePdfSave(new Uint8Array())}
      /> */}
      </Box>
    </>
  );
};

export default SignContract;
